// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const sapling = defineModel({
  id: "sapling",
  batchId: "future",
  name: "Sapling",
  tags: ["scenery","sapling","low-poly","age-of-mcp","future"],
  summary: "A young sapling — a planted tree growing back toward harvestable timber.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.18,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.008, 0.012, 0.1, 5), color: "#7a512c", position: [0, 0.05, 0] },
      { geometry: new THREE.SphereGeometry(0.04, 6, 4), color: "#6fb24f", position: [-0.03, 0.12, 0], scale: [1.4, 0.6, 1] },
      { geometry: new THREE.SphereGeometry(0.04, 6, 4), color: "#6fb24f", position: [0.03, 0.12, 0], scale: [1.4, 0.6, 1] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.012, 0.018, 0.3, 5), color: "#7a512c", position: [0, 0.15, 0] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.34, 4), color: "#9a7a4a", position: [0.05, 0.17, 0] },
      { geometry: new THREE.ConeGeometry(0.08, 0.2, 6), color: "#4f8a3e", position: [0, 0.34, 0] },
      { geometry: new THREE.SphereGeometry(0.06, 6, 5), color: "#62a64c", position: [0, 0.4, 0] },
    ] },
    { id: "variant-2", label: "Variant 3", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.02, 0.03, 0.5, 6), color: "#7a512c", position: [0, 0.25, 0] },
      { geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.4, 4), color: "#9a7a4a", position: [0.06, 0.2, 0] },
      { geometry: new THREE.ConeGeometry(0.16, 0.26, 7), color: "#4f8a3e", position: [0, 0.52, 0] },
      { geometry: new THREE.ConeGeometry(0.12, 0.22, 7), color: "#62a64c", position: [0, 0.68, 0] },
    ] },
  ],
  animations: [],
});
